import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fp3qc48xew: FaireBrandEntity = {
  token: "b_fp3qc48xew",
  type: "brand",
  name: "Jazeena",
  avatarUrl:
    "https://cdn.faire.com/fastly/ab336d69447f15debe8fe8c8dba01ace175065c7206c3c929fc8d98a77b5626c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c944ccefcb7eeade992c2afeca99052abfa10625e6a0607abe9049a410a05a9c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ab336d69447f15debe8fe8c8dba01ace175065c7206c3c929fc8d98a77b5626c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c944ccefcb7eeade992c2afeca99052abfa10625e6a0607abe9049a410a05a9c.jpeg",
  location: "Laguna Beach, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "Our founder, Jazeena, discovered the power of slowing down and self-care after leaving corporate burnout and moving to Bali, Indonesia. While at a wellness retreat, she received warm oil treatments that left her skin and her mind rejuvenated longer than anything she had tried before. From this inspiration, the Body Serum Candle was created. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:27.531Z",
    importedBy: "entity-db-cli",
  },
};
